import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Objects, Collections, Types} from "components";

import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import API from "@beardeddevops/react.api";
import {Button, Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, Label, Input} from "reactstrap";
import UniversalModalOverride from "../../../../../components/UniversalModalOverride";
import {
	ACQUISITION_KIOSK_MODE,
	buildAcquisitionFormsPath,
	buildAcquisitionKioskPath,
	getAcquisitionRouteId,
	setAcquisitionKioskSession
} from "../../../../../constants/AcquisitionKiosk";

const breadcrumbsStatic = [
	{
		name: 'Dashboard',
		url: '/',
		icon: 'dashboard',
	},
	{
		name: 'Acquisitions',
		url: '/acquisitions',
		icon: 'download',
	},
];
const RI060_SIGNATURE_OPTIONS = [
	{ key: "print_both", label: "Print both (with and without signature)" },
	{ key: "print_signature", label: "Print signature only" },
	{ key: "no_signature", label: "No signature" }
];
const DEFAULT_RI060_SIGNATURE_PREFERENCE = "print_signature";

class Acquisition extends Framework.Components.View {

	constructor(props) {
		super(props, 'details');
		this.state.toggleForm = false;
		this.state.location = '';
		this.state.location_binary_id = '';
		this.state.ri060SignatureModalOpen = false;
		this.state.ri060SignaturePreference = DEFAULT_RI060_SIGNATURE_PREFERENCE;
		this.state.ri060SetupError = '';
		this.state.ri060Locking = false;
		this.state.ri060HasAccountPin = false;
		this.state.ri060Pin_1 = '';
		this.state.ri060Pin_2 = '';
		this.state.ri060Pin_3 = '';
		this.state.ri060Pin_4 = '';

		this.ri060LockModel = new API.BuildClass(Types.Accounts._name, API.RequestType.READ);
		this.ri060PinRefs = [
			React.createRef(),
			React.createRef(),
			React.createRef(),
			React.createRef()
		];
	}

	toggle = (name) => () => {
		this.handleClose();
		this.setState({[name]: !this.state[name]});
	};

	handleOpen = (el) => event => {
		this.setState({
			[el]: event.currentTarget,
		});
	};

	handleClose = () => {
		this.setState({
			anchorGen: null,
		});
	};

	handleAfterP12Save = () => {
		this.refreshPage();
	}

	handleLocationUpdate = (location, location_binary_id) => {
		this.setState({ location, location_binary_id });
	};

	openRi060SignatureModal = () => {
		this.setState({
			ri060SignatureModalOpen: true,
			ri060SetupError: '',
			ri060HasAccountPin: !!this.props.rootState?.hasPin,
			ri060Pin_1: '',
			ri060Pin_2: '',
			ri060Pin_3: '',
			ri060Pin_4: ''
		});
	};

	closeRi060SignatureModal = () => {
		this.setState({ ri060SignatureModalOpen: false, ri060SetupError: '' });
	};

	handleRi060PinChange = (index) => (event) => {
		let value = event.target.value;

		if (value.length > 1) {
			value = value.slice(-1);
		}

		if (value !== '' && !/^\d$/.test(value)) {
			return;
		}

		const pinKey = `ri060Pin_${index + 1}`;
		this.setState({ [pinKey]: value }, () => {
			if (value !== '' && index < 3) {
				this.ri060PinRefs[index + 1].current?.focus();
			}
		});
	};

	handleRi060PinKeyDown = (index) => (event) => {
		const pinKey = `ri060Pin_${index + 1}`;
		if (event.key === 'Backspace' && this.state[pinKey] === '' && index > 0) {
			this.ri060PinRefs[index - 1].current?.focus();
		}
	};

	getRi060Pin = () => {
		return this.state.ri060Pin_1 + this.state.ri060Pin_2 + this.state.ri060Pin_3 + this.state.ri060Pin_4;
	};

	clearRi060Pin = () => {
		this.setState({
			ri060Pin_1: '',
			ri060Pin_2: '',
			ri060Pin_3: '',
			ri060Pin_4: ''
		});
	};

	renderRi060PinInputs = (autoFocusFirst = false) => {
		return (
			<div className="d-flex justify-content-center gap-2">
				{[0, 1, 2, 3].map((index) => {
					const pinKey = `ri060Pin_${index + 1}`;
					return (
						<Input
							key={index}
							innerRef={this.ri060PinRefs[index]}
							type="text"
							inputMode="numeric"
							maxLength={1}
							value={this.state[pinKey]}
							onChange={this.handleRi060PinChange(index)}
							onKeyDown={this.handleRi060PinKeyDown(index)}
							autoFocus={autoFocusFirst && index === 0}
							style={{
								width: '60px',
								height: '60px',
								fontSize: '24px',
								textAlign: 'center',
								fontWeight: 'bold'
							}}
						/>
					);
				})}
			</div>
		);
	};

	handleRi060Generate = async () => {
		const preference = this.state.ri060SignaturePreference;
		const requiresSignature = preference !== 'no_signature';
		const pin = this.getRi060Pin();
		const hasAccountPin = this.state.ri060HasAccountPin;
		const { collection, collection_binary_id } = this.getRi060CollectionIdentifiers();
		const routeId = getAcquisitionRouteId({ collection, collection_binary_id });

		if (preference === 'no_signature') {
			await this.printPdf(26, false, preference)();
			this.setState({ ri060SignatureModalOpen: false });
			return;
		}

		if (!requiresSignature) {
			return;
		}

		if (!hasAccountPin && pin.length !== 4) {
			this.setState({ ri060SetupError: 'Please enter a 4-digit PIN' });
			return;
		}
		if (!routeId) {
			this.setState({ ri060SetupError: 'Missing transaction identifiers' });
			return;
		}
		try {
			this.setState({ ri060Locking: true, ri060SetupError: '' });
			this.ri060LockModel.object.kiosk_mode = ACQUISITION_KIOSK_MODE;
			this.ri060LockModel.object.pin = hasAccountPin ? '' : pin;
			this.ri060LockModel.object.location = this.state.location;
			this.ri060LockModel.object.location_binary_id = this.state.location_binary_id;
			await this.ri060LockModel.submit(null, 'GET_LOCK');

			setAcquisitionKioskSession({
				collectionId: routeId,
				collection,
				collection_binary_id,
				routeId,
				lockedPath: buildAcquisitionKioskPath(routeId),
				returnPath: buildAcquisitionFormsPath(routeId),
				location: this.state.location,
				location_binary_id: this.state.location_binary_id,
				selectedForm: 'ri060',
				signaturePreference: preference,
				currentStep: 'signing',
				hasSigned: false,
				hasAccountPin,
				source: 'detail'
			});

			this.setState({
				ri060SignatureModalOpen: false,
				ri060Locking: false,
				ri060SetupError: '',
				ri060Pin_1: '',
				ri060Pin_2: '',
				ri060Pin_3: '',
				ri060Pin_4: ''
			});
			this.props.history.push(buildAcquisitionKioskPath(routeId));
		} catch (err) {
			this.setState({
				ri060SetupError: 'Failed to lock device: ' + (err.message || 'Unknown error'),
				ri060Locking: false
			});
		}
	};

	getRi060CollectionIdentifiers = () => {
		const id = this.props.id || this.props.match?.params?.id || '';
		const [collection_binary_id, collection] = id.split('-');
		return { collection_binary_id, collection };
	};

	printPdf = (form, sendEmail, signaturePreference = null) => async () => {
		let model = new API.BuildClass(Types.Transactions_Collections_Forms._name, API.RequestType.CREATE);
		model.object.form = form;
		model.object.send_email = sendEmail;
		model.object.location = this.state.location;
		model.object.location_binary_id = this.state.location_binary_id;
		if (form === 26 && signaturePreference) {
			model.object.ri060_signature_preference = signaturePreference;
		}
		model.parent = this.props.id || this.props.match?.params?.id;

		try {
			await model.submit(null, API.RequestType.CREATE);
		} catch (e) {
			return;
		}
		this.setState({tab: 'forms'})
		this.refreshPage();
	};

	handleToggleForm = () => {
		this.setState({toggleForm: !this.state.toggleForm})
	};

	generatedForm = () => {
		this.refreshPage();
		this.setState({tab: 'forms'});
	};

	render() {
		let breadcrumbs = breadcrumbsStatic.slice().concat([
			{
				name: this.state.name,
				url: `/acquisitions/${this.props.match.params.id}`,
				icon: 'file-text-o',
			}
		]);

		let hash = this.props.location.hash.replace('#', '');

		if (this.state.tab !== hash && hash !== "") {
			this.setState({tab: hash})
		}

		const ri060RequiresSignature = this.state.ri060SignaturePreference !== 'no_signature';

		return (
			<div className="container-fluid">

				<Framework.Components.PageBar breadcrumbs={breadcrumbs} history={this.props.history}>
					{this.props.rootState.hasNYP12Module &&
						<Button onClick={() => this.handleToggleForm()} size="sm" color="primary">
							<i className="fa fa-download"/>&nbsp;&nbsp;Generate New York P12 Form
						</Button>}
					{(this.props.rootState.hasMichiganRIModule || this.props.rootState.hasRIComboModule) &&
						<Button onClick={this.openRi060SignatureModal} size="sm" color="primary">
							<i className="fa fa-download"/>&nbsp;&nbsp;Generate Michigan RI-060 Form
						</Button>}
					{(this.props.rootState.hasRI060AModule || this.props.rootState.hasRIComboModule) &&
						<Button onClick={this.printPdf(29, false)} size="sm" color="primary">
							<i className="fa fa-download"/>&nbsp;&nbsp;Generate Michigan RI-060A Multiple Firearm Sale Form
						</Button>}
					{!this.props.kioskMode &&
						<Button onClick={this.toggle('modalUpload')} size="sm" color="primary">
							<i className="fa fa-check-square-o"/>&nbsp;&nbsp;Upload Files
						</Button>}
				</Framework.Components.PageBar>

				<Modal isOpen={this.state.ri060SignatureModalOpen} toggle={this.closeRi060SignatureModal} size="sm">
					<ModalHeader toggle={this.closeRi060SignatureModal}>
						Michigan RI-060 Signature Preference
					</ModalHeader>
					<ModalBody>
						{this.state.ri060SetupError && (
							<div className="alert alert-danger">{this.state.ri060SetupError}</div>
						)}
						<FormGroup>
							<Label><strong>Customer Signature</strong></Label>
							<Input
								type="select"
								value={this.state.ri060SignaturePreference}
								onChange={(e) => this.setState({ ri060SignaturePreference: e.target.value })}
							>
								{RI060_SIGNATURE_OPTIONS.map((option) => (
									<option key={option.key} value={option.key}>{option.label}</option>
								))}
							</Input>
						</FormGroup>
						{ri060RequiresSignature && !this.state.ri060HasAccountPin && (
							<FormGroup>
								<Label><strong>Enter Lock PIN</strong></Label>
								<p className="text-muted small">
									This PIN will be required to unlock the device after signing.
								</p>
								{this.renderRi060PinInputs(true)}
							</FormGroup>
						)}
						{ri060RequiresSignature && this.state.ri060HasAccountPin && (
							<div className="alert alert-success">
									<i className="fa fa-info-circle mr-2"/>
								Using account PIN
							</div>
						)}
					</ModalBody>
					<ModalFooter>
						<Button color="secondary" onClick={this.closeRi060SignatureModal} disabled={this.state.ri060Locking}>
							Cancel
						</Button>
						<Button color="primary" onClick={this.handleRi060Generate} disabled={this.state.ri060Locking}>
							{this.state.ri060Locking ? 'Locking...' : 'Continue'}
						</Button>
					</ModalFooter>
				</Modal>

				<Tabs value={this.state.tab} onChange={this.handleTabChange} component={'div'}>
					<Tab label="Acquisition" value="details"/>
					<Tab label="Change Log" value="logs"/>
					<Tab label="Uploaded Files" value={'upload'}/>
					{(this.props.rootState.hasImporterModule || this.props.rootState.hasNYP12Module) && <Tab label="forms" value="forms"/>}
				</Tabs>

				<div style={{display: this.state.tab === 'details' ? 'block' : 'none'}}>
					<Objects.Acquisition
						id={this.props.match.params.id}
						history={this.props.history}
						locations={this.props.locations}
						states={this.props.states}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						baseUrl={this.props.baseUrl}
						scannedCode={this.props.scannedCode}
						updateName={this.updateName}
						toggleForm={this.state.toggleForm}
						generatedForm={this.generatedForm}
						onLocationChange={this.handleLocationUpdate}
						userAccess={this.props.rootState.userAccess}
					/>
				</div>
				{this.state.tab === 'logs' &&
					<Collections.LogsAcquisitions
						parent={this.props.match.params.id}
						history={this.props.history}
						locations={this.props.locations}
						states={this.props.states}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
					/>}

				{this.state.tab === 'forms' &&
					<Collections.Forms
						parent={this.props.match.params.id}
						forForm={Types.Transactions_Collections_Forms._name}
						url="/transactions/[PARENT]/collections_forms"
						history={this.props.history}
						locations={this.props.locations}
						states={this.props.states}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						afterSave={this.handleAfterP12Save}
					/>}

				{this.state.tab === 'upload' &&
					<Collections.TransactionUploads
						parent={this.props.match.params.id}
						forForm={Types.Transactions_Collections_Forms._name}
						url="/transactions/[PARENT]/collections_forms"
						history={this.props.history}
						locations={this.props.locations}
						states={this.props.states}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
					/>}

				<UniversalModalOverride
					locations={this.props.locations}
					states={this.props.states}
					name="Upload Files"
					object={Objects.TransactionUpload}
					history={this.props.history}
					toggle={this.state.modalUpload}
					reportClose={this.reportClose('modalUpload')}
					afterSave={this.handleAfterSave}
					url="dispositions"
					size="xl"
				/>
			</div>
		)
	}
}

export default Framework.Components.withRootState(Acquisition);
